var indexOf = [].indexOf;

import featureNames from 'constants/feature_names';

angular.module('shared').controller('ShowFlagsModalCtrl', ["$scope", "$stateParams", "$window", "$modalInstance", "$http", "contactType", "contactId", "permissions", "dismissEndpoint", "flags", "addFlag", function($scope, $stateParams, $window, $modalInstance, $http, contactType, contactId, permissions, dismissEndpoint, flags, addFlag) {
  var baseUrl, gymId;
  gymId = $stateParams.gymId;
  $scope.permissions = permissions;
  $scope.featureNames = featureNames;
  $scope.canManage = indexOf.call(permissions, 'manage_contact_flags') >= 0;
  baseUrl = `/gyms/${gymId}/${contactType}/${contactId}/flags`;
  $scope.flags = flags;
  $scope.getTags = function(flag) {
    return flag.tag_list.join(', ');
  };
  $scope.dismiss = function(flag, index) {
    var message, url;
    message = "Are you sure?";
    if ($window.confirm(message)) {
      url = `${baseUrl}/${flag.id}/${dismissEndpoint}`;
      return $http.delete(url).then(function() {
        return $scope.flags.splice(index, 1);
      });
    }
  };
  $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
  $scope.canAddFlag = $scope.canManage && addFlag;
  return $scope.addFlag = function() {
    $scope.cancel();
    return addFlag();
  };
}]);
